export default __webpack_public_path__ + "static/bg_cta-06a981ed550a4c58d0128b0efa1336ac.jpg";